import { isValidPhoneNumber }                          from 'react-phone-number-input';
import { formatPhoneNumber as reactFormatPhoneNumber } from 'react-phone-number-input';

export default (num: number | string) => {
	const str = num.toString();
	return isValidPhoneNumber(str) ? reactFormatPhoneNumber(str) : str;
};
